import { http } from './http';
import type {
  RegisterEmailRequest,
  LoginEmailRequest,
  LoginPhoneRequest,
  SmsCodeRequest,
  LoginResponse,
  AuthTokens,
  ResetPasswordRequest,
  LoginWechatRequest,
} from '@daynote/shared-types';

export const authApi = {
  registerEmail: (data: RegisterEmailRequest) =>
    http.post<unknown, LoginResponse>('/auth/register/email', data),

  loginEmail: (data: LoginEmailRequest) =>
    http.post<unknown, LoginResponse>('/auth/login/email', data),

  loginPhone: (data: LoginPhoneRequest) =>
    http.post<unknown, LoginResponse>('/auth/login/phone', data),

  loginWechat: (data: LoginWechatRequest) =>
    http.post<unknown, LoginResponse>('/auth/login/wechat', data),

  sendSms: (data: SmsCodeRequest) => http.post('/auth/sms/send', data),

  resetPassword: (data: ResetPasswordRequest) => http.post('/auth/password/reset', data),

  refresh: (refreshToken: string) =>
    http.post<unknown, AuthTokens>('/auth/refresh', { refreshToken }),

  logout: (refreshToken?: string) => http.post('/auth/logout', { refreshToken }),

  deleteAccount: () => http.delete('/auth/account'),
};
